"use strict";

require("core-js/modules/es.array.join");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeMessageListener = void 0;

var _fullscript = require("../../fullscript");

var initializeMessageListener = function initializeMessageListener(options, dispatcher) {
  var domain = options.domain,
      env = options.env;
  var origin = domain !== null && domain !== void 0 ? domain : _fullscript.FULLSCRIPT_DOMAINS[env];
  window.addEventListener("message", function (e) {
    // !!!! Absolutely required for security purposes !!!!!
    // We need to check that the message comes from a valid domain, i.e. fullscript itself
    if (e.origin !== origin) return;

    if (e.data.type === "serverError") {
      throw new Error(e.data.payload.join("\n"));
    }

    dispatcher.dispatch(e.data.type, e.data.payload);
  });
};

exports.initializeMessageListener = initializeMessageListener;